"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var CommonReleaseOverview_1 = require("../model/CommonReleaseOverview");

var SelloutImpactRecordStockValues_1 = require("../model/sellout/SelloutImpactRecordStockValues");

var SelloutImpactRecordValuesForOpen_1 = require("../model/sellout/SelloutImpactRecordValuesForOpen");

var CommonReleaseOverviewConverter_1 = require("./CommonReleaseOverviewConverter");

var SelloutImpactRecordConverter_1 = require("./sellout/SelloutImpactRecordConverter");

var SelloutReleasePreviousOpenOverviewConverter_1 = require("./sellout/SelloutReleasePreviousOpenOverviewConverter");
/**
 * @author Jan Prokop
 */


var CommonReleaseOverviewConverterImpl =
/*#__PURE__*/
function (_CommonReleaseOvervie) {
  _inherits(CommonReleaseOverviewConverterImpl, _CommonReleaseOvervie);

  function CommonReleaseOverviewConverterImpl(selloutImpactRecordConverter, selloutReleasePreviousOpenOverviewConverter) {
    var _this;

    _classCallCheck(this, CommonReleaseOverviewConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CommonReleaseOverviewConverterImpl).call(this));
    _this.selloutImpactRecordConverter = selloutImpactRecordConverter;
    _this.selloutReleasePreviousOpenOverviewConverter = selloutReleasePreviousOpenOverviewConverter;
    return _this;
  }

  _createClass(CommonReleaseOverviewConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new CommonReleaseOverview_1.CommonReleaseOverview(CommonReleaseOverview_1.CommonReleaseOverview.schema.id.valueOf(conversions.documentToClassId(source)), CommonReleaseOverview_1.CommonReleaseOverview.schema.name.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.releaseType.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.workflowType.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.state.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.pricingType.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.priceListType.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.cmDeadline.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.priceValidityStartDate.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.endDate.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.exported.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.favourite.valueOfField(source), CommonReleaseOverview_1.CommonReleaseOverview.schema.totalPriceChangeLimit.valueOfField(source), source.minPriceChangeInPercent != null ? conversions.toBigNumber(source.minPriceChangeInPercent) : null, source.maxPriceChangeInPercent != null ? conversions.toBigNumber(source.maxPriceChangeInPercent) : null, source.minMarginChangeInPercent != null ? conversions.toBigNumber(source.minMarginChangeInPercent) : null, source.stockValues != null ? this.selloutImpactRecordConverter.toPartialObject(source.stockValues, conversions, SelloutImpactRecordStockValues_1.SelloutImpactRecordStockValues) : null, source.currentImpact != null ? this.selloutImpactRecordConverter.toPartialObject(source.currentImpact, conversions, SelloutImpactRecordValuesForOpen_1.SelloutImpactRecordValuesForOpen) : null, conversions.asObjectList(source, 'previousOpens', function (previousOpen) {
        return _this2.selloutReleasePreviousOpenOverviewConverter.toObject(previousOpen, conversions);
      }));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      return Object.assign(Object.assign({}, conversions.classToDocumentId(source)), {
        name: source.name,
        releaseType: source.releaseType,
        workflowType: source.workflowType,
        state: source.state,
        pricingType: source.pricingType,
        priceListType: source.priceListType,
        cmDeadline: source.cmDeadline && conversions.fromDate(source.cmDeadline),
        priceValidityStartDate: source.priceValidityStartDate && conversions.fromDate(source.priceValidityStartDate),
        endDate: source.endDate && conversions.fromDate(source.endDate),
        exported: source.exported && conversions.fromDate(source.exported),
        favourite: source.favourite,
        totalPriceChangeLimit: source.totalPriceChangeLimit,
        minPriceChangeInPercent: source.minPriceChangeInPercent && conversions.fromBigNumber(source.minPriceChangeInPercent),
        maxPriceChangeInPercent: source.maxPriceChangeInPercent && conversions.fromBigNumber(source.maxPriceChangeInPercent),
        minMarginChangeInPercent: source.minMarginChangeInPercent && conversions.fromBigNumber(source.minMarginChangeInPercent),
        stockValues: source.stockValues && this.selloutImpactRecordConverter.toPartialDocument(source.stockValues, conversions),
        currentImpact: source.currentImpact && this.selloutImpactRecordConverter.toPartialDocument(source.currentImpact, conversions),
        previousOpens: conversions.asObjectArray(source, 'previousOpens', function (previousOpen) {
          return _this3.selloutReleasePreviousOpenOverviewConverter.toDocument(previousOpen, conversions);
        })
      });
    }
  }, {
    key: "fromReleaseDocument",
    value: function fromReleaseDocument(source, conversions) {
      return this.toObject(Object.assign(Object.assign({}, source), {
        previousOpens: source.reopenSnapshots
      }), conversions);
    }
  }]);

  return CommonReleaseOverviewConverterImpl;
}(CommonReleaseOverviewConverter_1.CommonReleaseOverviewConverter);

CommonReleaseOverviewConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutImpactRecordConverter_1.SelloutImpactRecordConverter, SelloutReleasePreviousOpenOverviewConverter_1.SelloutReleasePreviousOpenOverviewConverter])], CommonReleaseOverviewConverterImpl);
exports.CommonReleaseOverviewConverterImpl = CommonReleaseOverviewConverterImpl;